import { useState } from 'react'
import { FoundationsCopy } from '../Types/FoundationsTypes'
function CopyIcon(props: FoundationsCopy) {
    const [checked, setChecked] = useState(false)
    const copyToClipboard = (e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.stopPropagation()
        setChecked(true)
        navigator.clipboard.writeText(props.copyText)
        setTimeout(function () {
            setChecked(false)
        }, 1500)
        return true
    }
    return (
        <span
            title="Copy to Clipboard"
            className={`foundations-copy feather ${checked ? 'icon-check' : 'icon-copy'}`}
            onClick={copyToClipboard}
        ></span>
    )
}

export { CopyIcon }
